<script>
import Drawer from './components/Drawer.svelte';
</script>

<style>

</style>

<Drawer />

<div class="container">
<h1>Offline mode</h1>
<h2>Pretty useless without the internet</h2>
</div>